export const storage = {
	save(key, data) {
		localStorage.setItem(key, JSON.stringify(data));
	},
	get(key) {
		try {
			return JSON.parse(localStorage.getItem(key));
		} catch (err) {
			return undefined;
		}
	},
	remove(key) {
		localStorage.removeItem(key);
	}
};
